import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import PrivacyView from '@/views/PrivacyView.vue'
import HotPursuit from '@/views/HotPursuitView.vue'
import LaowaiSurvival from '@/views/LaowaiSurvivalView.vue'
import StellarCollect from '@/views/StellarCollectView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      title: 'Club Baby Pro — studio indépendant de jeux mobiles',
      description: 'Club Baby Pro crée des jeux mobiles indépendants sur Android : Stellar Collect, Laowai Survival et Hot Pursuit.'
    }
  },
  {
    path: '/hotpursuit',
    name: 'hotpursuit',
    component: HotPursuit,
    meta: {
      title: 'Hot Pursuit — course-poursuite arcade gratuite sur Android | Club Baby Pro',
      description: 'Semez la police, survivez le plus longtemps possible et débloquez des véhicules (voitures de sport, camions, bus) dans Hot Pursuit. Gratuit sur Google Play, noté 4,8/5.'
    }
  },
  {
    path: '/laowai-survival',
    name: 'laowai-survival',
    component: LaowaiSurvival,
    meta: {
      title: 'Laowai Survival — jeu narratif humoristique sur Android | Club Baby Pro',
      description: 'Survivez aux situations du quotidien en Chine dans Laowai Survival, un jeu mobile narratif à choix en anglais et français.'
    }
  },
  {
    path: '/stellar-collect',
    name: 'stellar-collect',
    component: StellarCollect,
    meta: {
      title: 'Stellar Collect — jeu idle clicker spatial gratuit sur Android | Club Baby Pro',
      description: 'Minez des astéroïdes au doigt, pilotez votre vaisseau et faites tourner vos drones même hors ligne. Stellar Collect est un idle clicker spatial en 3D low-poly, gratuit sur Android, en français, anglais et espagnol.'
    }
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: PrivacyView,
    meta: {
      title: 'Politique de confidentialité — Hot Pursuit | Club Baby Pro',
      description: 'Politique de confidentialité du jeu Hot Pursuit de Club Baby Pro. Aucune donnée personnelle n\'est collectée.'
    }
  }
]

const router = new VueRouter({
  routes
})

// Met à jour le <title> et la meta description à chaque changement de page
router.afterEach((to) => {
  const meta = to.meta || {}
  if (meta.title) {
    document.title = meta.title
  }
  if (meta.description) {
    let tag = document.querySelector('meta[name="description"]')
    if (!tag) {
      tag = document.createElement('meta')
      tag.setAttribute('name', 'description')
      document.head.appendChild(tag)
    }
    tag.setAttribute('content', meta.description)
  }
})

export default router
